document.addEventListener("DOMContentLoaded", () => {
  const btnsPlay = document.querySelectorAll('.video-play')
  if(btnsPlay.length <= 0 ) return;

  btnsPlay.forEach( btn => {
    btn.onclick = () =>{
      btn.style.display = "none";

      const video = btn.closest(".video-content").querySelector(".s-video")
      if(!video) return;

      video.controls = true;
      video.play();
    }
  })
});

